import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { ApiService } from '../service/api_service';
@Component({
    selector: 'app-header',
    template: require('./header.component.html'),
    styles: [require('./header.component.css')]
})
export class HeaderComponent implements OnInit {
    name: string;
    MenuList: any;
    static parameters = [ApiService];
    constructor(private apiService: ApiService) {
    }

    clickme: boolean = false;

    ngOnInit() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.name = token.username;
        this.MenuList = [];
        this.getMenuList(token.clientId);
    }

    getMenuList(clientId) {
        this.apiService.getMenuList({ clientId: clientId }).subscribe((res: any) => {
            var Data = res.data;
            console.log('Data', Data);
            this.MenuList = this.ListToTree(Data);
            console.log('this.MenuList', this.MenuList);
        })
    }

    ListToTree(list) {
        var map = {}, node, roots = [], i;
        for (i = 0; i < list.length; i += 1) {
            map[list[i].Code] = i;
            list[i].children = [];
        }
        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.ParentCode !== '') {
                list[map[node.ParentCode]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

    add() {
        this.clickme = true;
    }

    logout() {
        sessionStorage.removeItem("currentUser");
        sessionStorage.removeItem('access_token');
        //Router.navigate(['/login']);
    }

    private toggle: boolean = false;
    sidebarClickEVent(event) {
        this.toggle = !this.toggle;
    }
}
